import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const MUTATION = gql`
  mutation ApplyBrandTerm($originalText: String!, $termInText: String!, $replaceWith: String!) {
    applyBrandTerm(
      originalText: $originalText
      termInText: $termInText
      replaceWith: $replaceWith
    ) {
      updatedText

      changes {
        paragraph
        start
        originText
        newText
      }
    }
  }
`;

export const applyBrandTerm = async ({ originalText, termInText, replaceWith }) => {
  const result = await apolloClient.mutate({
    mutation: MUTATION,
    variables: { originalText, termInText, replaceWith },
  });

  return getSingleProp(result.data);
};
